import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDelphiComponent } from './simple-icons-delphi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDelphiComponent ],
    exports:      [ SimpleIconsDelphiComponent ],
    bootstrap:    []
})
export class SimpleIconsDelphiModule {}
